import { useRuntimeConfig, useState } from '#imports'

import { useNethone } from '@backmarket/nuxt-layer-fraud/useNethone'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useIsE2ETestingEnvironment } from '@backmarket/nuxt-module-qa/useIsE2ETestingEnvironment'

export function useNethoneOnProfile() {
  const logger = useLogger()

  const config = useRuntimeConfig()
  const isEnabled = config.public.FF_NETHONE_ENABLED

  const isE2ETestingEnvironment = useIsE2ETestingEnvironment()

  const hasStartedFingerprinting = useState(() => false)

  if (!isEnabled || isE2ETestingEnvironment || hasStartedFingerprinting.value) {
    return
  }

  const loadStartTime = performance.now()

  const { onLoaded, initialize } = useNethone()

  const onScriptLoaded = async () => {
    const loadTime = performance.now() - loadStartTime
    logger.info('Nethone script loaded', {
      owners: ['bot-squad-identity'],
      loadTimeMs: loadTime,
    })

    const profileStartTime = performance.now()

    try {
      await initialize({
        sensitiveFields: [],
        secretFields: [],
      })

      hasStartedFingerprinting.value = true

      const profileTime = performance.now() - profileStartTime
      logger.info('Nethone profiling completed', {
        owners: ['bot-squad-identity'],
        profileTimeMs: profileTime,
      })
    } catch (err: unknown) {
      const profileTime = performance.now() - profileStartTime
      logger.error('Nethone profiling failed', {
        owners: ['bot-squad-identity'],
        profileTimeMs: profileTime,
        error: err instanceof Error ? err : new Error(String(err)),
      })
    }
  }

  onLoaded(onScriptLoaded)
}
